import React, { Component } from 'react'
import PropTypes from 'prop-types'

// CSS
import './CoverImage.css'

class CoverImage extends Component {

    static propTypes = {
        image: PropTypes.string,
        title: PropTypes.string
    }

    render() {

        if(this.props.image) {
            return (
                <div className="cover-image">
                    <img src={this.props.image} alt={this.props.title} />
                </div>
            )
        } else {
            return null
        }

    }
}

export default CoverImage;


// WEBPACK FOOTER //
// ./src/components/coverimage/CoverImage.js